/**
 * Step 9 - Establish an immediate action plan.
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';
import ActionStep from './ActionStep';
import ButtonNext from './ButtonNext';
import ButtonPrevious from './ButtonPrevious';

function ActionPlan({
  addActionStep,
  nextStep,
  paragraphData,
  previousStep,
  resultActionSteps,
  stateOfReadiness,
  updateActionStep,
}) {
  const {
    fieldActionAction,
    fieldContemplationAction,
    fieldDesiredAttributes,
    fieldMaintenanceAction,
    fieldPreparationAction,
    fieldText,
    fieldTitle,
  } = paragraphData;
  const actions = [];
  const boxes = fieldDesiredAttributes.map((attribute, index) =>
    <div
      key={`box-${index}`}
      dangerouslySetInnerHTML={{
        __html: attribute.value,
      }}
    />,
  );
  let exampleAction;
  if (stateOfReadiness === 'contemplation') {
    exampleAction = fieldContemplationAction;
  } else if (stateOfReadiness === 'action') {
    exampleAction = fieldActionAction;
  } else if (stateOfReadiness === 'maintenance') {
    exampleAction = fieldMaintenanceAction;
  } else if (stateOfReadiness === 'preparation') {
    exampleAction = fieldPreparationAction;
  }
  // Create an input group for each element in the action steps array.
  resultActionSteps.map((action, index) =>
    actions.push(
      <ActionStep
        addActionStep={addActionStep}
        index={index}
        key={`action-step-${index}`}
        stepData={resultActionSteps[index]}
        updateActionStep={updateActionStep}
      />,
    ),
  );
  return (
    <div
      className={classnames({
        'goal--step-nine': true,
      })}
    >
      <h4
        dangerouslySetInnerHTML={{
          __html: fieldTitle[0] ? fieldTitle[0].value : '',
        }}
      />
      <div
        className={classnames({
          description: true,
        })}
        dangerouslySetInnerHTML={{
          __html: fieldText[0].value,
        }}
      />
      <div
        className={classnames({
          boxes: true,
        })}
      >
        {boxes}
      </div>
      <div
        className={classnames({
          'action-steps': true,
        })}
      >
        {actions}
      </div>
      <div>
        <button
          onClick={addActionStep}
          style={{
            background: 'transparent',
            color: '#ff8f4b',
          }}
        >
          Add Another Action Step
        </button>
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: exampleAction ? exampleAction[0].value : null,
        }}
        style={{
          lineHeight: '1.5em',
        }}
      />
      <ButtonPrevious
        previousStep={previousStep}
      />
      <ButtonNext
        nextStep={nextStep}
      />
      <div
        style={{
          fontSize: '16px',
          color: '#aaa',
        }}
      >
        Step 9 of 10
      </div>
    </div>
  );
}

ActionPlan.propTypes = {
  addActionStep: PropTypes.func,
  nextStep: PropTypes.func,
  paragraphData: PropTypes.shape({}),
  previousStep: PropTypes.func,
  resultActionSteps: PropTypes.arrayOf(PropTypes.shape({})),
  stateOfReadiness: PropTypes.string,
  updateActionStep: PropTypes.func,
};

export default ActionPlan;



// WEBPACK FOOTER //
// js/src/goals/ActionPlan.js